export type TWOFASTAGETYPE = 'email-otp' | 'authenticator-qr' | 'authenticator-otp' | 'authenticator-backup-code';

export const twoFaStageTitle: Record<TWOFASTAGETYPE, string> = {
	'email-otp': 'Email Authentication',
	'authenticator-qr': 'Authenticator App',
	'authenticator-otp': 'Authenticator App OTP',
	'authenticator-backup-code': 'Backup Code',
};

export interface IAuthenticatorBackupCodeProps {
	onNext?: () => void;
	recoveryCodes: string[];
}

export type TwoFaActionType =
	| 'deactivate-authenticator'
	| 'activate-authenticator'
	| 'init-authenticator'
	| 'disable-email'
	| 'enable-email';

export type TwoFaCategory = 'email' | 'authenticator';
